module.exports = __webpack_public_path__ + "static/media/circle.c898fecc.png";